import axios from "axios";
import config from "config/config";

axios.defaults.baseURL = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].API_BASE_URL;

export const REDEEM_HISTORY = `/api/v1/customer/redeem-history`;
export const REDEEM_POINTS = `/api/v1/customer/redeem-points`;
export const GIFT_CARD_REQUEST = `/api/v1/customer/redemption-request`;
export const EXPIRE_REDEEM_POINTS = `/api/v1/customer/expire-points`;
export const DECRYPT_CLAIM_CODE = `/api/v1/customer/decrypt-claim-code`;

// getRedeemHistory API
export function getRedeemHistory(page) {
  return axios.get(`${REDEEM_HISTORY}?page=${page}`, {
    validateStatus(status) {
      return true;
    },
  });
}
// redeem points
export function getRedeemPoints() {
  return axios.get(REDEEM_POINTS, {
    validateStatus(status) {
      return true;
    },
  });
}
//expire redeem points
export function expireRedeemPoints() {
  return axios.get(EXPIRE_REDEEM_POINTS, {
    validateStatus(status) {
      return true;
    },
  });
}
// request generate gift card
export function generateGiftCard(selectedValue) {
  return axios.post(
    GIFT_CARD_REQUEST,
    { email: selectedValue },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}

export function getDecryptedClaimCode(giftcardId) {
  return axios.post(
    `${DECRYPT_CLAIM_CODE}`,
    {
      giftcardId,
    },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}
